export const logoutUser = ({ auth, dispatch }) => {

  // Broadcast logout to other tabs (force event by using timestamp)
  localStorage.setItem("logout", Date.now().toString());
  localStorage.removeItem("logout");
  
  if (dispatch) {
    dispatch({ type: "user/logOut" });
  }

  if (!auth.activeNavigator) {
    auth.signoutRedirect({
      id_token_hint: auth.user?.id_token,
      revokeTokens: true,
      post_logout_redirect_uri: `${window.location.origin}/`,
    });
  }
};
